import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmService, ConfirmOptions } from '../../services/confirm.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css',
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0 }))
      ])
    ]),
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(20px) scale(0.95)', opacity: 0 }),
        animate('300ms cubic-bezier(0.16, 1, 0.3, 1)', style({ transform: 'translateY(0) scale(1)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(20px) scale(0.95)', opacity: 0 }))
      ])
    ])
  ]
})
export class ConfirmDialogComponent implements OnInit {
  private confirmService = inject(ConfirmService);

  isOpen = false;
  options: ConfirmOptions | null = null;
  private resolveFn: ((result: boolean) => void) | null = null;

  ngOnInit() {
    this.confirmService.confirm$.subscribe(({ options, resolve }) => {
      this.options = options;
      this.resolveFn = resolve;
      this.isOpen = true;
    });
  }

  confirm() {
    if (this.resolveFn) {
      this.resolveFn(true);
    }
    this.close();
  }

  cancel() {
    if (this.resolveFn) {
      this.resolveFn(false);
    }
    this.close();
  }

  private close() {
    this.isOpen = false;
    this.options = null;
    this.resolveFn = null;
  }
}
